import React, { useState, useEffect } from "react";
import {
  Table,
  Card,
  Space,
  Modal,
  Tooltip,
  message,
  Button,
  Form,
  Input,
} from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import "./faqs.css";
import { callApi } from "../../api/apiCaller";
import { routes } from "../../api/routes";

const { TextArea } = Input;

const Faqs = () => {
  const [faqs, setFaqs] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedFaq, setSelectedFaq] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const getAllFaq = () => {
    callApi(
      "GET",
      `${routes.getAllFaq}`,
      null,
      setLoading,
      (res) => {
        setFaqs(res?.data?.faq || []);
      },
      (err) => console.log(err)
    );
  };

  useEffect(() => {
    getAllFaq();
  }, []);

  const handleAddFaq = () => {
    setSelectedFaq(null);
    form.resetFields();
    setIsModalOpen(true);
  };

  const handleEdit = (record) => {
    setSelectedFaq(record);
    form.setFieldsValue({ title: record.question, answer: record.answer });
    setIsModalOpen(true);
  };

  const handleSubmit = async (values) => {
    const method = selectedFaq ? "PATCH" : "POST";
    const url = selectedFaq
      ? `${routes.getAllFaq}/${selectedFaq?._id}`
      : `${routes.createFaq}`;
    const body = { question: values.title, answer: values.answer };

    callApi(
      method,
      url,
      body,
      setLoading,
      (res) => {
        if (res.status === 200) {
          message.success(
            `FAQ ${selectedFaq ? "Updated" : "Created"} successfully!`
          );
          getAllFaq();
          setIsModalOpen(false);
        } else {
          message.error(res.message);
        }
      },
      (err) => console.log(err)
    );
  };

  const deleteFaq = (id) => {
    callApi(
      "DELETE",
      `${routes.getAllFaq}/${id}`,
      null,
      setLoading,
      (res) => {
        if (res.status === 200) {
          message.success("Faq Deleted successfully!");
          getAllFaq();
        }
      },
      (err) => console.log(err)
    );
  };

  const columns = [
    {
      title: "Question",
      dataIndex: "question",
      key: "question",
      className: "column-question",
      render: (text) => <strong className="faq-q-text">{text}</strong>,
    },
    {
      title: "Answer",
      dataIndex: "answer",
      key: "answer",
      render: (text, record) => (
        <span>
          {text.length > 70 ? `${text.substring(0, 70)}...` : text}
          {text.length > 70 && (
            <Button
              type="link"
              className="theme-link"
              onClick={() => {
                setSelectedFaq(record);
                setIsViewModalOpen(true);
              }}
            >
              More
            </Button>
          )}
        </span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 120,
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <Tooltip title="Edit">
            <EditOutlined
              onClick={() => handleEdit(record)}
              className="action-icon edit-btn"
            />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteOutlined
              onClick={() => deleteFaq(record?._id)}
              className="action-icon delete-btn"
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div className="faq-page-container">
      <div className="faq-header-flex">
        <h2 className="faq-page-title">FAQ Management</h2>
        <Button
          type="primary"
          size="large"
          icon={<PlusOutlined />}
          className="primary-theme-btn"
          onClick={handleAddFaq}
        >
          Add New FAQ
        </Button>
      </div>

      <Card className="faq-card-table">
        <Table
          columns={columns}
          dataSource={faqs}
          rowKey="_id"
          pagination={{ pageSize: 7 }}
          scroll={{ x: 700 }}
          className="erchonia-custom-table"
        />
      </Card>

      {/* Form Modal */}
      <Modal
        title={selectedFaq ? "Edit FAQ" : "Add New FAQ"}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        centered
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="theme-form"
        >
          <Form.Item
            label="Question"
            name="title"
            rules={[{ required: true, message: "Please enter question" }]}
          >
            <Input size="large" placeholder="Enter the FAQ question" />
          </Form.Item>
          <Form.Item
            label="Answer"
            name="answer"
            rules={[{ required: true, message: "Please enter answer" }]}
          >
            <TextArea
              size="large"
              rows={5}
              placeholder="Provide the detailed answer here..."
            />
          </Form.Item>
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            loading={loading}
            block
            className="primary-theme-btn"
          >
            {selectedFaq ? "Update FAQ" : "Save FAQ"}
          </Button>
        </Form>
      </Modal>

      {/* Preview Modal */}
      <Modal
        title="FAQ Preview"
        open={isViewModalOpen}
        onCancel={() => setIsViewModalOpen(false)}
        footer={[
          <Button
            key="close"
            type="primary"
            className="primary-theme-btn"
            onClick={() => setIsViewModalOpen(false)}
          >
            Close
          </Button>,
        ]}
        centered
      >
        <div className="faq-preview-content">
          <h3 className="preview-q">{selectedFaq?.question}</h3>
          <p className="preview-a">{selectedFaq?.answer}</p>
        </div>
      </Modal>
    </div>
  );
};

export default Faqs;
